export default {
  name: 'personal-center',
  path: 'personal-center',
  component: () => import('@/views/personal-center/PersonalCenter.vue'),
  meta: { title: '个人中心', redirect: false, hideSubMenu: true, },
};